import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSDevolucaoSaldoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async listar(params = {}) {
    try {
      const cleaned = {};
      Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      return await this.api.get('/devolucao-saldo', { params: cleaned });
    } catch (err) {
      this.error.errorShow(err);
      throw err;
    }
  }
}
